export const REQUEST_GET_ALL_CLIENTS = 'client/REQUEST_GET_ALL_CLIENTS';
export const RECEIVED_ALL_CLIENTS = 'client/RECEIVED_ALL_CLIENTS';
export const RECEIVED_ERROR = 'client/CUSTOMER_ERROR';
